import React, { useState, useEffect, useMemo } from 'react';
import './PayTicketDetailModal.css';
import './SequencePickerModal.css';

// Loupe du champ "Sequence" de Nullify Ticket (2026-10-02) : liste TOUTES les
// fiches actives de la banque a la date choisie (memes filtres Online/Local +
// loterie que la recherche, juste sans SQ/No — le backend renvoie alors tout),
// SQ en gras, avec un champ pour filtrer (SQ, N°, loterie, montant). Cliquer
// une fiche la choisit (`onSelect(ticket)`).
// `search` = portal.search (company ou superviseur), meme reponse que la recherche.
const SequencePickerModal = ({ search, params, onSelect, onClose }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    search({ ...params, sq: '', no: '' })
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? [...data] : [];
        list.sort((a, b) => (a.sq ?? 0) - (b.sq ?? 0));
        setTickets(list);
      })
      .catch(() => { if (!cancelled) setError('Impossible de charger les fiches.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [search, params]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return tickets;
    return tickets.filter((t) => [t.sq, t.no, t.tirage_name, t.total_amount]
      .some((v) => String(v ?? '').toLowerCase().includes(q)));
  }, [tickets, query]);

  return (
    <div className="ptm-overlay" onClick={onClose}>
      <div className="ptm-modal spm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ptm-header">
          <span className="ptm-title">Choisir une fiche</span>
          <button type="button" className="ptm-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="ptm-body">
          <input
            className="spm-search"
            type="text"
            placeholder="Chercher : sequence, N°, loterie, montant..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
          />

          {loading && <p className="spm-info">Chargement...</p>}
          {error && <p className="ptm-error">{error}</p>}
          {!loading && !error && (
            <p className="spm-info">{filtered.length} fiche(s){query ? ` sur ${tickets.length}` : ''}</p>
          )}

          {!loading && !error && (
            <table className="ptm-table spm-table">
              <thead>
                <tr><th>SQ</th><th>No</th><th>Loterie</th><th>Total</th><th>Heure</th></tr>
              </thead>
              <tbody>
                {filtered.map((t) => (
                  <tr key={t.id} className="spm-row" onClick={() => onSelect(t)}>
                    <td className="spm-sq">{t.sq ?? '—'}</td>
                    <td>{t.no ?? '—'}</td>
                    <td>{t.tirage_name}</td>
                    <td className="ptm-amount">{Number(t.total_amount || 0).toFixed(2)}</td>
                    <td>{new Date(t.created_at).toLocaleTimeString()}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={5} className="spm-empty">Aucune fiche.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="ptm-footer">
          <button type="button" className="ptm-close-action" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default SequencePickerModal;
